<template>
  <div class="wrapper wrapper-content white-bg">
    <div class="ibox-content" style="direction: rtl">
      <div class="row">
        <!-- <div class="col-sm-6">
          <h5>From:</h5>
          <address>
            <strong>Inspinia, Inc.</strong><br />
            106 Jorg Avenu, 600/10<br />
            Chicago, VT 32456<br />
            <abbr title="Phone">P:</abbr> (123) 601-4590
          </address>
        </div> -->

        <div class="col-sm-6 text-right">
          <h4>شماره فاکتور</h4>
          <h4 class="text-navy">{{ order.tracking_code }}</h4>
          <span>آدرس:</span>
          <address>
            <strong
              >{{ order.city }},
              {{ order.state }}</strong
            ><br />
            {{ order.address }}<br />
            {{ order.postal_code }}<br />
            <span>شماره تماس:</span> {{ order.mobile }} -
            {{ order.tel }}
          </address>
          <p>
            <span
              ><strong>تاریخ فاکتور:</strong>
              {{ $getJalaliDate(order.created_at) }}</span
            >
          </p>
        </div>
      </div>

      <div class="table-responsive m-t k-rtl" style="text-align: right">
        <table class="table invoice-table">
          <thead>
            <tr>
              <th>نام محصول</th>
              <th>تعداد</th>
              <th>قیمت واحد(ریال)</th>
              <th>مبلغ کل(ریال)</th>
              <th>مبلغ تخفیف(ریال)</th>
              <th>مبلغ کل پس از تخفیف(ریال)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in order.items" :key="index">
              <td>
                <div>
                  <strong>{{ item.product.name }} <br/> <small>{{ item.combination_text }}</small></strong>
                </div>
                <!-- <small>{{ item.product_price.title }}</small> -->
              </td>
              <td>{{ item.count }}</td>
              <td>{{ $thousandSeprator(item.price) }}</td>
              <td>{{ $thousandSeprator(item.price * item.count) }}</td>
              <td>{{ $thousandSeprator(item.price - item.payable_price) }}</td>
              <td>{{ $thousandSeprator(item.payable_price * item.count) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /table-responsive -->

      <table class="table invoice-total">
        <tbody>
          <tr>
            <td><strong>جمع کل :</strong></td>
            <td>{{ $thousandSeprator(order.total) }}</td>
          </tr>
          <tr>
            <td><strong>تخفیف :</strong></td>
            <td>{{ $thousandSeprator(order.discount) }}</td>
          </tr>
          <tr>
            <td><strong>هزینه حمل :</strong></td>
            <td>{{ $thousandSeprator(order.shipping_price) }}</td>
          </tr>
          <tr>
            <td><strong>مبلغ نهایی سفارش :</strong></td>
            <td>{{ $thousandSeprator(order.payable) }}</td>
          </tr>
        </tbody>
      </table>
      <!-- <div class="well m-t">
        <strong>Comments</strong>
        It is a long established fact that a reader will be distracted by the
        readable content of a page when looking at its layout. The point of
        using Lorem Ipsum is that it has a more-or-less
      </div> -->
    </div>
  </div>
</template>
<script>
import { orderApi } from "@/api/apiManagement";
export default {
  data() {
    return {
      order: {},
    };
  },
  mounted() {
    this.$setLayout("simple-layout");
    this.loadOrder();
  },
  methods: {
    loadOrder() {
      let orderID = this.$route.params.id;
      this.$setIsLoading(true);
      orderApi
        .findOrder(orderID)
        .then((res) => {
          this.order = res.data;
          setTimeout(function () {
            window.print();
          }, 1000);
        })
        .finally(() => this.$setIsLoading(false));
    },
  },
};
</script>
<style>
body {
  background-color: #fff !important;
}
@media print {
  @page {
    size: landscape;
  }
}
</style>
<style scoped>
tr {
  font-size: 10px;
}
</style>
